module.exports = __webpack_public_path__ + "static/media/Red1.c4998c16.png";